import * as Sentry from "@sentry/vue";
import {CaptureConsole} from '@sentry/integrations';
import {Integrations} from "@sentry/tracing";

export default {
    install(Vue, dsn) {
        if (dsn) {
            Sentry.init({
                Vue: Vue,
                dsn: dsn,
                integrations: [
                    new CaptureConsole({
                        levels: ['error']
                    }),
                    new Integrations.BrowserTracing()
                ],
                tracingOptions: {
                    trackComponents: true,
                },
            });
        }
    }
};
